import { useTranslation } from 'react-i18next';
interface IProps {
  handle: () => void;
}

export const UpdateAvailable = (props: IProps) => {
  const { handle } = props;
  const { t } = useTranslation();
  return (
    <div>
      <div className="flex flex-col items-center justify-center h-10 bg-transparent ">
        <div className="flex flex-row items-center justify-center">
          <span className="text-xs l sm:text-base ">{t('hasNewUpdate')}</span>
          <button
            onClick={() => handle()}
            type="button"
            className="text-blue-00
            py-1.5 px-3  border-0 text-xs l sm:text-base rounded-borderRadius10 outline-none bg-transparent hover:bg-blue-95 "
          >
            <span className="">{t('updateNow')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateAvailable;
